import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../pages/LoadingSpinner';

const AuthGuard = ({ children }) => {
    const { user, isLoading } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const isKeyAvailable = localStorage.getItem('SecurityToken') !== null;
        if (!isLoading && !user && location.pathname !== '/' && location.pathname !== '/saml-callback' && location.pathname !== '/dashboard' && location.pathname !== '/general-information' && location.pathname !== '/glassbox-viewer' && location.pathname !== '/admin') {
            navigate('/', { replace: true });
        }
        else if (!isLoading && !user && location.pathname === '/dashboard') {
            if (isKeyAvailable) {
                navigate('/dashboard', { replace: true });
            }
            else {
                navigate('/', { replace: true });
            }
        }
        else if (!isLoading && !user && location.pathname === '/general-information') {
            if (isKeyAvailable) {
                navigate('/general-information', { replace: true });
            }
            else {
                navigate('/', { replace: true });
            }
        }
        else if (!isLoading && !user && location.pathname === '/glassbox-viewer') {
            
             if (isKeyAvailable) {
                navigate('/glassbox-viewer', { replace: true });
            }
            else {
                navigate('/', { replace: true });
            }
        }
        else if (!isLoading && !user && location.pathname === '/admin') {
           
             if (isKeyAvailable) {
                navigate('/admin', { replace: true });
            }
            else {
                navigate('/', { replace: true });
            }
        }

    }, [user, isLoading, location.pathname, navigate]);

    if (isLoading) {
        return <LoadingSpinner />;
    }

    return children;
};

export default AuthGuard;
